'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCarousel = function () {
  function ImageCarousel(el) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, ImageCarousel);

    var _this = this;
    var context = { context: el };

    this.els = {
      el: el,
      itemsContainer: (0, _functional.getElement)('.sec-CarouselFiftyFifty_Items', context),
      items: (0, _functional.getElements)('.sec-CarouselFiftyFifty_Item', context),
      controls: (0, _functional.getElement)('.sec-CarouselFiftyFifty_Controls', context),
      prevControl: (0, _functional.getElement)('.sec-CarouselFiftyFifty_Control-prev', context),
      nextControl: (0, _functional.getElement)('.sec-CarouselFiftyFifty_Control-next', context),
      thumbnails: (0, _functional.getElements)('.sec-CarouselFiftyFifty_Thumbnail', context),
      thumbnailButtons: (0, _functional.getElements)('.sec-CarouselFiftyFifty_ThumbnailButton', context)
    };

    this.slidesCount = this.els.items.length;

    this.carousel = new _siema2.default({
      selector: this.els.itemsContainer,
      duration: 500,
      perPage: 1,
      onInit: function onInit() {
        _this.initialiseThumbnails(this);
        _this.initialiseControls(this);
      },
      onChange: function onChange() {
        _this.updateThumbnailActiveState(this);
        _this.scrollActiveThumbnailIntoView(this);
      }
    });

    this.calculateControlsHeight();
    window.addEventListener('resize', function () {
      return _this2.calculateControlsHeight();
    });
  }

  (0, _createClass3.default)(ImageCarousel, [{
    key: 'calculateControlsHeight',
    value: function calculateControlsHeight() {
      var controlsHeight = this.els.controls.clientHeight;
      if (!controlsHeight) return;

      this.els.el.parentElement.style.setProperty('--carousel-controls-height', controlsHeight + 'px');
    }
  }, {
    key: 'initialiseThumbnails',
    value: function initialiseThumbnails(carousel) {
      this.els.thumbnailButtons.forEach(function (button) {
        var thumbnail = button.closest('.sec-CarouselFiftyFifty_Thumbnail');
        if (!thumbnail) return;

        var thumbnailIndex = thumbnail.dataset.thumbnailIndex || 0;

        button.addEventListener('click', function () {
          return carousel.goTo(thumbnailIndex);
        });
      });
    }
  }, {
    key: 'scrollActiveThumbnailIntoView',
    value: function scrollActiveThumbnailIntoView(carousel) {
      var activeThumbnail = this.els.thumbnails.find(function (thumbnail) {
        return Number(thumbnail.dataset.thumbnailIndex) === carousel.currentSlide;
      });
      if (!activeThumbnail) return;
      activeThumbnail.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }, {
    key: 'updateThumbnailActiveState',
    value: function updateThumbnailActiveState(carousel) {
      this.els.thumbnails.forEach(function (thumbnail) {
        var index = Number(thumbnail.dataset.thumbnailIndex);
        if (index === carousel.currentSlide) {
          thumbnail.setAttribute('data-active', 'true');
        } else {
          thumbnail.removeAttribute('data-active');
        }
      });
    }
  }, {
    key: 'initialiseControls',
    value: function initialiseControls(carousel) {
      var _this3 = this;

      var checkIfControlsShouldBeDisabled = function checkIfControlsShouldBeDisabled(carousel) {
        carousel.currentSlide === 0 ? _this3.els.prevControl.setAttribute('disabled', true) : _this3.els.prevControl.removeAttribute('disabled');

        carousel.currentSlide === _this3.slidesCount - 1 ? _this3.els.nextControl.setAttribute('disabled', true) : _this3.els.nextControl.removeAttribute('disabled');
      };

      // On load
      checkIfControlsShouldBeDisabled(carousel);
      this.updateThumbnailActiveState(carousel);

      // Events
      this.els.prevControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return carousel.prev();

              case 2:

                checkIfControlsShouldBeDisabled(carousel);
                _this3.updateThumbnailActiveState(carousel);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      })));
      this.els.nextControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return carousel.next();

              case 2:

                checkIfControlsShouldBeDisabled(carousel);
                _this3.updateThumbnailActiveState(carousel);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      })));
    }
  }]);
  return ImageCarousel;
}();

exports.default = ImageCarousel;